module.exports = __webpack_public_path__ + "images/b918a8958fc9ccaef7662cf9e265aab6-illu_floodSensor.png";